module.exports = __webpack_public_path__ + "10ce4268d521d3c0eede48effc6b867e.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1154
// module chunks = 0